module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/graubuenden-8e208d0aebc83c46755326678042643d.png";